import { render, staticRenderFns } from "./_ProductPrice.vue?vue&type=template&id=c933acd6"
import script from "./_ProductPrice.vue?vue&type=script&lang=js"
export * from "./_ProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports